import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { InputGroup } from "react-bootstrap";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";

const NURSERY_SUB_TYPE = {
    A: ["가정", "국공립", "민간", "법인·단체등", "법인단체", "부모협동", "사회복지법인", "직장", "협동"],
    S: ["공립(단설)", "공립(병설)", "국립", "병설", "사립(법인)", "사립(사인)", "사설"],
    X: ["기타"],
};

const NURSERY_SERVICE_TYPE = {
    N: {name: "일반", show: false, color: "text-info"},
    B: {name: "지사용", show: true, color: "text-success"},
    T: {name: "테스트용", show: true, color: "text-danger"},
};

const NURSERY_DEFAULT_VALUE = {
    id: 0,
    code: "",
    name: "",
    type: "",
    sub_type: "",
    ceo: "",
    director: "",
    sido: "",
    sigungu: "",
    addr: "",
    tel: "",
    class_2: 0,
    class_3: 0,
    class_4: 0,
    class_5: 0,
    class_mix: 0,
    class_2_childs: 0,
    class_3_childs: 0,
    class_4_childs: 0,
    class_5_childs: 0,
    class_mix_childs: 0,
    service_status: "운영",
};

const NurseryFormTable = ({ nursery }) => {
    const [nurseryCodeModal, showNurseryCodeModal] = useState(0);
    const [data, setData] = useState(nursery || NURSERY_DEFAULT_VALUE);

    const [codes, setCodes] = useState([]);
    const [sidoList, setSidoList] = useState([]);
    const [sigunguList, setSigunguList] = useState([]);

    const [subTypeOptions, setSubTypeOptions] = useState([]);

    useEffect(() => {
        if (codes.length <= 0) {
            getLocCodes();
        }

        if (nursery) {
            setData(nursery);
            setSubTypeOptions(NURSERY_SUB_TYPE[nursery.type]);
        } else {
            setData(NURSERY_DEFAULT_VALUE);
        }
        return () => {};
    }, [nursery]);

    const getLocCodes = () => {
		commonData.getLocCodes(axios, (err, result) => {
			if(!err) {
                setCodes(result);
                if (result.length > 0) {
                    const _data = { ...data };
                    setSidoList(result);
                    if (nursery && nursery.sido) {
                        const sidoCode = result.filter((r) => "" + r.code === nursery.sido);
                        setSigunguList(sidoCode[0].child);
                    } else {
                        setSigunguList(result[0].child);
                        _data.sido = result[0].code;
                        _data.sigungu = result[0].child[0].code;
                    }

                    setData(_data);
                }
            }
        });
    };

    const onChangeSido = (e) => {
        const value = e.target.value;
        if (codes && sidoList) {
            const _data = { ...data };
            _data.sido = value;
            const sido = sidoList.filter((sido) => {
                return "" + sido.code === value;
            });
            if (sido && sido.length >= 1) {
                setSigunguList(sido[0].child);
                _data.sigungu = sido[0].child[0].code;
            }
            setData(_data);
        }
    };

    const onChangeType = (e) => {
        const value = e.target.value;
        if (value) {
            setSubTypeOptions(NURSERY_SUB_TYPE[value]);
        } else {
            setSubTypeOptions([]);
        }

        const _data = { ...data };
        _data.sub_type = "";
        setData(_data);

        inputHandler(e);
    };

    const inputHandler = (e) => {
        const { name, value, type } = e.target;
        const _data = { ...data };

        if (type === "number" && value === "") {
            _data[name] = 0;
        } else {
            _data[name] = value;
        }

        setData(_data);
    };

    window.getNurseryFormData = () => {
        return data;
    };

    const isAdmin = localStorage.getItem("login_user_type") === "admin";
    let serviceType = false;
    if (isAdmin && data) {
        serviceType = true;
    }

    return (
        <table className="table table-bordered bg-light">
            <colgroup>
                <col style={{ minWidth: "100px", width: "20%" }} />
                <col />
                <col style={{ minWidth: "100px", width: "20%" }} />
                <col />
            </colgroup>
            <tbody>
                {data.id > 0 && (
                    <tr>
                        <th className="bg-dark text-light">원 코드(ID)</th>
                        <td colSpan="3">
                            {data.code && <span className="text-danger">{data.code}</span>}
                            {!data.code && (
                                <>
                                    <button
                                        className="btn btn-brand btn-rounded"
                                        onClick={() => {
                                            showNurseryCodeModal(true);
                                        }}
                                    >
                                        원 코드 발급
                                    </button>
                                    <NurseryCodeModal
                                        id={data.id}
                                        name={data.name}
                                        show={nurseryCodeModal}
                                        onHide={(code) => {
                                            const _data = { ...data };
                                            _data.code = code;
                                            setData(_data);
                                            showNurseryCodeModal(false);
                                        }}
                                    />
                                </>
                            )}
                            <select className="form-control float-right" name="service_status" value={data.service_status} style={{ width: "100px" }} onChange={inputHandler}>
                                <option value="운영">운영</option>
                                <option value="폐지">폐지</option>
                                <option value="휴지">휴지</option>
                                <option value="재개">재개</option>
                            </select>
                            {serviceType && (
                                <select className="form-control float-right" name="service_type" value={data.service_type} style={{ width: "100px" }} onChange={inputHandler}>
                                    <option value="N">일반</option>
                                    <option value="B">지사용</option>
                                    <option value="T">테스트용</option>
                                </select>
                            )}
                        </td>
                    </tr>
                )}
                <tr>
                    <th className="bg-dark text-light">원명</th>
                    <td colSpan="3">
                        <input className="form-control" type="text" name="name" value={data.name} placeholder="교육청 또는 구청에 신고된 정확한 기관 명을 입력하세요" onChange={inputHandler} />
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">분류</th>
                    <td>
                        <select className="form-control" name="type" onChange={onChangeType} value={data.type}>
                            <option value="">선택</option>
                            <option value="S">유치원</option>
                            <option value="A">어린이집</option>
                            <option value="X">기타</option>
                        </select>
                    </td>
                    <th className="bg-dark text-light">유형</th>
                    <td>
                        <select className="form-control" name="sub_type" onChange={inputHandler} value={data.sub_type} disabled={subTypeOptions.length <= 0}>
                            <option value="">선택</option>
                            {subTypeOptions.map((subType) => {
                                return (
                                    <option value={subType} key={`opt-type-${subType}`}>
                                        {subType}
                                    </option>
                                );
                            })}
                        </select>
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">대표자 명</th>
                    <td>
                        <input className="form-control" type="text" name="ceo" value={data.ceo} placeholder="필수 입력" onChange={inputHandler} />
                    </td>
                    <th className="bg-dark text-light">원장 명</th>
                    <td>
                        <input className="form-control" type="text" name="director" maxLength="20" value={data.director} placeholder="필수 입력" onChange={inputHandler} />
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">주소</th>
                    <td colSpan="3">
                        <InputGroup className="input-group my-group">
                            <InputGroup.Prepend className="input-group-append">
                                <InputGroup.Text style={{ width: "50px", justifyContent: "center", height: "38px" }}>시/도</InputGroup.Text>
                            </InputGroup.Prepend>
                            <select className="form-control  input-group-append" onChange={onChangeSido} value={data.sido || ""}>
                                <option value="">선택</option>
                                {sidoList &&
                                    sidoList.map((sido, idx) => {
                                        return (
                                            <option value={sido.code} key={`nursery-address-sido-${idx}`}>
                                                {sido.name}
                                            </option>
                                        );
                                    })}
                            </select>
                            <InputGroup.Append>
                                <InputGroup.Text style={{ width: "80px", justifyContent: "center", height: "38px" }}>시/군/구</InputGroup.Text>
                            </InputGroup.Append>
                            <select className="form-control  input-group-append" name="sigungu" value={data.sigungu || ""} onChange={inputHandler}>
                                <option value="">선택</option>
                                {sigunguList &&
                                    sigunguList.map((sigungu, idx) => {
                                        return (
                                            <option value={sigungu.code} eng_name={sigungu.eng_min_name} key={`nursery-address-sigungu-${idx}`}>
                                                {sigungu.name}
                                            </option>
                                        );
                                    })}
                            </select>
                        </InputGroup>
                        <InputGroup className="input-group my-group mt-1">
                            <InputGroup.Prepend className="input-group-append">
                                <InputGroup.Text style={{ width: "100px", justifyContent: "center" }}>상세주소</InputGroup.Text>
                            </InputGroup.Prepend>
                            <input
                                className="form-control input-group-append"
                                type="text"
                                name="addr"
                                value={data.addr}
                                placeholder="시/도, 시/군/구를 제외한 상세주소를 입력해주세요"
                                onChange={inputHandler}
                            />
                        </InputGroup>
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">원 전화번호</th>
                    <td colSpan="3">
                        <input className="form-control" type="text" name="tel" value={data.tel} maxLength="20" placeholder="기관 대표 유선전화번호를 입력하세요(02-123-1234)" onChange={inputHandler} />
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">연령/반/원아 수</th>
                    <td className="p-0" colSpan="3">
                        <table className="table table-striped">
                            <colgroup>
                                <col style={{ width: "70px" }} />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col style={{ width: "60px" }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th className="bg-dark text-light">연령</th>
                                    <th className="bg-dark text-light">만2세</th>
                                    <th className="bg-dark text-light">만3세</th>
                                    <th className="bg-dark text-light">만4세</th>
                                    <th className="bg-dark text-light">만5세</th>
                                    <th className="bg-dark text-light">기타</th>
                                    <th className="bg-dark text-light">총합</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>반 수</td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_2" value={data.class_2} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_3" value={data.class_3} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_4" value={data.class_4} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_5" value={data.class_5} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_mix" value={data.class_mix} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>{Number(data.class_2 || 0) + Number(data.class_3 || 0) + Number(data.class_4 || 0) + Number(data.class_5 || 0) + Number(data.class_mix || 0)}</td>
                                </tr>
                                <tr>
                                    <td>원아 수</td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_2_childs" value={data.class_2_childs} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_3_childs" value={data.class_3_childs} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_4_childs" value={data.class_4_childs} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_5_childs" value={data.class_5_childs} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        <input className="form-control p-1" type="number" name="class_mix_childs" value={data.class_mix_childs} onChange={inputHandler} min="0" />
                                    </td>
                                    <td>
                                        {Number(data.class_2_childs || 0) +
                                            Number(data.class_3_childs || 0) +
                                            Number(data.class_4_childs || 0) +
                                            Number(data.class_5_childs || 0) +
                                            Number(data.class_mix_childs || 0)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const NurseryCodeModal = ({ id, name, show, onHide }) => {
    const [loadingData, setLoadingData] = useState(false);
    const [validateCode, isValidateCode] = useState(false);
    const [engCode, setEngCode] = useState("");
    const [code, setCode] = useState("");
    const [msg, setMsg] = useState("");

    useEffect(() => {
        if (show) {
            setEngCode(document.getElementsByName("sigungu")[0].selectedOptions[0].attributes["eng_name"].value);
        }
        if (id && name) {
            setCode(getEngKeyboard(name));
        }
        return () => {};
    }, [id, name, show]);

    const checkDuplicateId = () => {
        if (!engCode) {
            setMsg("지역코드가 비어있습니다.\n팝업 창을 닫고 다시 시도해주세요.");
            return;
        }
        if (!code) {
            setMsg("코드는 빈칸으로 둘 수 없습니다.\n코드를 입력해주세요.");
            return;
        }
        const eng_num = /^[a-z0-9+]*$/;
        if (!eng_num.test(engCode + code)) {
            setMsg("코드는 영어 소문자와 숫자만 사용 가능합니다.");
            return;
        }

        setMsg("");
        setLoadingData(true);

        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/nursery/code/${engCode + code}`,
        })
            .then((res) => {
                if (res.data && res.data.cnt > 0) setMsg("코드가 중복 되었습니다.");
                else onHide(engCode + code);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                isValidateCode(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    return (
        <Modal show={show} onHide={onHide} aria-labelledby="example-custom-modal-styling-title">
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">원 코드 발급</Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
                <div>
                    <p>
                        등록된 주소지와 원명을 기반으로 코드가 발급 됩니다. <br />
                        <span className="text-primary">코드가 중복</span> 되거나 <span className="text-primary">필요한 경우</span> <span className="text-danger">뒷부분 코드를 수정</span>해주세요.
                    </p>
                </div>
                <div className="mt-2">
                    <InputGroup className="input-group my-group mt-1">
                        <InputGroup.Prepend className="input-group-append">
                            <InputGroup.Text style={{ width: "100px", justifyContent: "center" }}>{engCode}</InputGroup.Text>
                        </InputGroup.Prepend>
                        <input
                            className="form-control input-group-append"
                            type="text"
                            name="code"
                            value={code}
                            onChange={(e) => {
                                setCode(e.target.value.trim());
                            }}
                            maxLength={4}
                        />
                    </InputGroup>
                </div>
                {msg && (
                    <div>
                        <p className="text-danger">{msg}</p>
                    </div>
                )}
                <div className="mt-3">
                    <button className="btn btn-primary btn-block" onClick={checkDuplicateId}>
                        적용
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

const getEngKeyboard = (word) => {
    /** 초성 - 가(ㄱ), 날(ㄴ) 닭(ㄷ) */
    var arrChoSung = [0x3131, 0x3132, 0x3134, 0x3137, 0x3138, 0x3139, 0x3141, 0x3142, 0x3143, 0x3145, 0x3146, 0x3147, 0x3148, 0x3149, 0x314a, 0x314b, 0x314c, 0x314d, 0x314e];

    /** 초성 - 가(ㄱ), 날(ㄴ) 닭(ㄷ) */
    var arrChoSungEng = ["r", "R", "s", "e", "E", "f", "a", "q", "Q", "t", "T", "d", "w", "W", "c", "z", "x", "v", "g"];
    /** 중성 - 가(ㅏ), 야(ㅑ), 뺨(ㅑ)*/
    var arrJungSungEng = ["k", "o", "i", "O", "j", "p", "u", "P", "h", "hk", "ho", "hl", "y", "n", "nj", "np", "nl", "b", "m", "ml", "l"];
    /** 종성 - 가(없음), 갈(ㄹ) 천(ㄴ) */
    var arrJongSungEng = ["", "r", "R", "rt", "s", "sw", "sg", "e", "f", "fr", "fa", "fq", "ft", "fx", "fv", "fg", "a", "q", "qt", "t", "T", "d", "w", "c", "z", "x", "v", "g"];
    /** 단일 자음 - ㄱ,ㄴ,ㄷ,ㄹ... (ㄸ,ㅃ,ㅉ은 단일자음(초성)으로 쓰이지만 단일자음으론 안쓰임) */
    var arrSingleJaumEng = ["r", "R", "rt", "s", "sw", "sg", "e", "E", "f", "fr", "fa", "fq", "ft", "fx", "fv", "fg", "a", "q", "Q", "qt", "t", "T", "d", "w", "W", "c", "z", "x", "v", "g"];

    var result = "";
    word = word.replace(/ /gi, "");
    var count = word.length > 2 ? 3 : word.length;

    for (var i = 0; i < count; i++) {
        var chars = word.charCodeAt(i) - parseInt("0xac00", 16);
        if (chars >= 0 && chars <= 11172) {
            var chosung = parseInt(chars / (21 * 28));
            result += arrChoSungEng[chosung];
        } else {
            if (chars >= -31439 && chars <= -31410) {
                /* 단일자음인 경우 */
                var jaum = parseInt(chars + 31439);
                result = result + arrSingleJaumEng[jaum];
            } else if (chars >= -31409 && chars <= -31389) {
                /* 단일모음인 경우 */
                var moum = parseInt(chars + 31409);
                result = result + arrJungSungEng[moum];
            } else {
                /* 알파벳인 경우 */
                result = result + String.fromCharCode(chars + parseInt("0xAC00", 16));
            }
        } //if
    }
    return result;
};

export default NurseryFormTable;
